module.exports = __webpack_public_path__ + "img/hopways-02.afb22149.webp";